export default __webpack_public_path__ + "static/media/logo-h.3ad73300.png";